import type { Analytics } from '@mwl/core-lib';

export const filterAnalytics: Analytics<'click'> = {
  click: { eventName: 'sportTopMenu_filter_btn_click', data: {} },
};
